import ReactDOM from 'react-dom';

const Portal = ({ portalId, children }) => {
  const destination = document.getElementById(portalId);
  return ReactDOM.createPortal(children, destination);
};

export default Portal;
